import { AzureIntegration } from "@/api/useIntegrations.types"

export const isAzureInstallation = (
  arr: unknown
): arr is AzureIntegration[] => {
  return (
    Array.isArray(arr) &&
    arr.every(
      (obj) =>
        obj &&
        typeof obj === "object" &&
        "organizationName" in obj &&
        obj.organizationName &&
        "reposCount" in obj &&
        typeof obj.reposCount === "number"
    )
  )
}
